import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/home/Index.vue';
import Detail from './views/detail/Detail.vue';
import List from './views/list/List.vue';
import JobList from './views/list/JobList.vue';
import Search from './views/search/Search.vue';
import Msg from './views/msg/Msg.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/detail/:id',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/list/:type',
      name: 'List',
      component: List
    },
    {
      path: '/job-list',
      name: 'JobList',
      component: JobList
    },
    {
      path: '/search/:keyword',
      name: 'Search',
      component: Search
    },
    {
      path: '/msg/:tno',
      name: 'Msg',
      component: Msg
    }
  ]
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
